import { FunctionComponent, SVGProps, useId } from 'react'

export const IconFileCheck: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  id,
  ...props
}) => {
  const paint0 = `${id}-paint0`
  const paint1 = `${id}-paint1`
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.66797 25.6673H21.0013C21.6201 25.6673 22.2136 25.4215 22.6512 24.9839C23.0888 24.5463 23.3346 23.9528 23.3346 23.334V8.75065L16.918 2.33398H7.0013C6.38246 2.33398 5.78897 2.57982 5.35139 3.0174C4.9138 3.45499 4.66797 4.04848 4.66797 4.66732V9.33398"
        stroke={`url(#${paint0})`}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 17.4993L5.83333 19.8327L10.5 15.166"
        stroke={`url(#${paint1})`}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={paint0}
          x1="14.0013"
          y1="2.33398"
          x2="14.0013"
          y2="25.6673"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0"
            stopColor={props.color ?? 'white'}
            stopOpacity="0.8"
          />
          <stop
            offset="1"
            stopColor={props.color ?? 'white'}
            stopOpacity="0.6"
          />
        </linearGradient>
        <linearGradient
          id={paint1}
          x1="7"
          y1="15.166"
          x2="7"
          y2="19.8327"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0"
            stopColor={props.color ?? 'white'}
            stopOpacity="0.8"
          />
          <stop
            offset="1"
            stopColor={props.color ?? 'white'}
            stopOpacity="0.6"
          />
        </linearGradient>
      </defs>
    </svg>
  )
}
